module.exports = __webpack_public_path__ + "static/media/2-MODIL.8df8a5c4.mp3";